import { useState } from 'react'
import { FaCloudArrowUp, FaStore } from 'react-icons/fa6'
import apiClient from '../../../services/apiClient'
import { DashboardImage } from '../AdminShared'
import { AdminMediaLibrary } from '../media/AdminMediaLibrary'

export function ListingBuilder({ apiToken, onRefresh } = {}) {
  const [selectedImage, setSelectedImage] = useState(null)
  const [isMediaOpen, setIsMediaOpen] = useState(false)
  const [uploadStatus, setUploadStatus] = useState('')

  const handleSubmit = async (event) => {
    event.preventDefault()
    if (!apiToken) return

    const formElement = event.currentTarget
    const form = new FormData(formElement)
    const title = String(form.get('title') || '').trim()

    if (!title) {
      setUploadStatus('Product title is required.')
      return
    }

    try {
      setUploadStatus('Publishing listing...')

      await apiClient.createBuyNowListing(apiToken, {
        title,
        category: form.get('category'),
        price: Number(form.get('price') || 0),
        inventory: Number(form.get('inventory') || 1),
        bundleEligible: form.get('bundleEligible') === 'yes',
        quickCheckout: true,
        status: 'published',
        images: selectedImage ? [selectedImage] : [],
      })

      formElement.reset()
      setSelectedImage(null)
      setUploadStatus('')
      await onRefresh?.('Buy-now listing published')
    } catch (error) {
      setUploadStatus(error.message || 'Listing publish failed')
    }
  }

  return (
    <>
      <form className="tactical-card obc-admin__builder" onSubmit={handleSubmit}>
        <div className="obc-admin__panel-head">
          <h2>Create Buy-Now Listing</h2>
          <span>Fixed price inventory</span>
        </div>
        <div className="obc-admin__form-grid">
          <label>Product title<input name="title" placeholder="Listing title" /></label>
          <label>Category<select name="category" defaultValue="Cards"><option value="Cards">Cards</option><option value="Memorabilia">Memorabilia</option></select></label>
          <label>Price<input name="price" placeholder="149" type="number" min="0" /></label>
          <label>Inventory<input name="inventory" placeholder="1" type="number" min="1" /></label>
          <label>Bundle eligible<select name="bundleEligible" defaultValue="yes"><option value="yes">Yes</option><option value="no">No</option></select></label>
        </div>
        <div className="obc-admin__upload-row">
          <button className="obc-admin__file-button" type="button" onClick={() => setIsMediaOpen(true)}>
            <FaCloudArrowUp /> {selectedImage ? selectedImage.title || selectedImage.originalName || 'Image selected' : 'Choose Media'}
          </button>
          <button type="submit"><FaStore /> Publish Listing</button>
        </div>
        {uploadStatus ? <small className="obc-admin__form-status">{uploadStatus}</small> : null}
      </form>
      <AdminMediaLibrary
        apiToken={apiToken}
        open={isMediaOpen}
        onClose={() => setIsMediaOpen(false)}
        onSelect={setSelectedImage}
      />
    </>
  )
}

export function BuyNowInventoryManager({ apiToken, rows = [], onRefresh }) {
  const updateListing = async (row, payload, message) => {
    if (!apiToken || !row.rawId) return

    try {
      await apiClient.updateBuyNowListing(apiToken, row.rawId, payload)
      await onRefresh?.(message)
    } catch (error) {
      await onRefresh?.(error.message || 'Inventory update failed')
    }
  }

  return (
    <section className="tactical-card obc-admin__builder">
      <div className="obc-admin__panel-head">
        <div>
          <h2>Buy-Now Inventory</h2>
          <span>Restock, publish, pause, and monitor fixed-price listings</span>
        </div>
      </div>
      <div className="obc-order-admin-grid">
        {rows.map((row) => (
          <article key={row.rawId || row.item}>
            <DashboardImage src={row.image} alt={row.item} />
            <div>
              <strong>{row.item}</strong>
              <span>{row.category} / {row.price}</span>
              <small>{row.inventory} / held {row.held} / sold {row.sold}</small>
              <small>Status: {row.status}</small>
            </div>
            <div className="obc-consignment-admin-actions">
              <button type="button" onClick={() => updateListing(row, { inventory: row.rawInventory + 1, status: 'published' }, 'Inventory restocked')}>+1 Stock</button>
              <button type="button" onClick={() => updateListing(row, { status: 'published' }, 'Listing published')}>Publish</button>
              <button type="button" onClick={() => updateListing(row, { status: 'draft' }, 'Listing paused')}>Pause</button>
              <button type="button" onClick={() => updateListing(row, { inventory: 0, status: 'draft' }, 'Listing marked sold out')}>Sold Out</button>
            </div>
          </article>
        ))}
      </div>
    </section>
  )
}

export function AdminShopModule({ apiToken, listingRows, onRefresh }) {
  return (
    <div className="obc-admin__section">
      <ListingBuilder apiToken={apiToken} onRefresh={onRefresh} />
      <BuyNowInventoryManager apiToken={apiToken} rows={listingRows} onRefresh={onRefresh} />
    </div>
  )
}
